/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/SpiderTemplate/SpiderCardAnimator',[
        'lodash',
        'pixi',
        'util/dictionary',
        'Arkadium/GameEngine/Core/EngineManagers',
        'Arkadium/GameEngine/Scenes/Nodes/SpriteNode',
        'Arkadium/GameEngine/Tween/Tween',
        'SolitaireShared/CardLogic/CardOp',
        'CardUI/PileView',
        'CardUI/CardView',
        'CardUI/SupplyView',
        'absolute/particleemitter'
    ], function (_, PIXI, Dictionary, EngineManagers, SpriteNode, Tween, CardOp, PileView, CardView, SupplyView, ParticleEmitter) {
    "use strict";

    var SpiderCardAnimator = function (supplyView) {
        this.initSpiderCardAnimator(supplyView);
    };



    SpiderCardAnimator.prototype.trailParticles = function(cardView, start, end) {

        if(this.cleanUpTimeout !== null) {
            window.clearTimeout(this.cleanUpTimeout);
            this.cleanUpTimeout = null;
        }

        if(!this.particleLayer) {
            this.particleLayer = new PIXI.DisplayObjectContainer();
        }

        var trailEmitterOptions = {
                rate: { numpan: {a: 5, b: 8, center: true}, timepan: { a: 0.01, b: 0.02, center: null }},
                mass: 1,
                rotation: { a: [5,10,15,20,25,30,35,40,45], b: [0,3], style: 'add' },
                velocity: 0.65,
                alpha: { a: [0,1], b: 0 },
                scale: { a: [0.2,0.02], b: 0, center: null},
                gravity: 0,
                life: {a: 1, b: 2, center: null},
                radius: 1,
                parent: this.particleLayer,
                crossZone: null,
                randomDrift: null
            },
            endEmitterOptions = {
                rate: { numpan: {a: 50, b: 100, center: null}, timepan: { a: 0.1, b: 0.2, center: null }},
                mass: 1,
                rotation: { a: [5,10,15,20,25,30,35,40,45], b: [0,3], style: 'add' },
                velocity: [1.5,1.2,0.8,0.2],
                alpha: { a: [0.5,1], b: 0 },
                scale: { a: [0.2,0.02], b: 0, center: null},
                gravity: 1,
                life: {a: 0, b: 2, center: null},
                radius: 1,
                crossZone: null,
                randomDrift: null
            },
            textures = [PIXI.Texture.fromFrame('Star.png'), PIXI.Texture.fromFrame('Star_orng_dot.png'), PIXI.Texture.fromFrame('Star_yellow_dot.png')],
            trailEmitter = new ParticleEmitter(EngineManagers.UI, textures, trailEmitterOptions),
            endEmitter = new ParticleEmitter(EngineManagers.UI, textures, endEmitterOptions),
            self = this;

        this.emitters.push(trailEmitter);
        this.emitters.push(endEmitter);

        EngineManagers.UI.stage[0].addChild(trailEmitter);
        EngineManagers.UI.stage[0].addChild(endEmitter);
        EngineManagers.UI.stage[0].addChild(this.particleLayer);

        trailEmitter.x = start.x;
        trailEmitter.y = start.y;

        endEmitter.x = end.x;
        endEmitter.y = end.y;

        var trailTween = new TWEEN.Tween({x: start.x, y: start.y})
            .easing(TWEEN.Easing.Linear.None)
            .delay(300)
            .onStart(function(){
                trailEmitter.start();
                EngineManagers.Sounds.PlaySound("completeStack_chime");
            })
            .to({x: end.x, y: end.y}, 800)
            .onUpdate(function(){
                trailEmitter.x = this.x;
                trailEmitter.y = this.y;
            })
            .onComplete(function(){
                trailEmitter.stop();
                endEmitter.emitOnce();
                self.cleanUpTimeout = window.setTimeout(function() {
                    self.cleanUpParticles();
                }, 5000);

            })
            .start();

    };

    SpiderCardAnimator.prototype.initSpiderCardAnimator = function (supplyView) {
        this.SupplyView = supplyView;
        this.AnimationDelayTimer = 0;

        this.AnimationList = new Dictionary(SpriteNode, Array);
        this.FlippedPileList = new Dictionary(PileView, PileView);
        this.TweenCache = new Dictionary(SpriteNode, Tween);

        this.IsInAnimationSet = false;
        this.IsUndoing = false;
        this.IsDeal = false;
        this.DealCardNum = 0;

        this.NextAnimationDelay = 0;
        this.AnimatingAction = null;

        this.IsShuffling = false;

        this.showButterfly = false;

        this.nextAnimationAction = null;

        this.emitters = [];
        this.cleanUpTimeout = null;

        this.movingRunToFoundation = false;
    };


    SpiderCardAnimator.ROTATION_ANGLE = Math.PI;
    SpiderCardAnimator.ANIMATION_LENGTH = 0.2;
    SpiderCardAnimator.ANIMATION_DELAY = 0.3;
    SpiderCardAnimator.CARD_DELAY = 0.05;

    SpiderCardAnimator.ANIM_LENGTH_DRAW = 0.6;
    SpiderCardAnimator.CARD_DELAY_DRAW = 0.1;


    SpiderCardAnimator.AnimationEntry = function (pos, rot, scale, cardFlip, wait, speed, sound) {
        this.initAnimationEntry(pos, rot, scale, cardFlip, wait, speed, sound);
    };

    SpiderCardAnimator.AnimationEntry.prototype.initAnimationEntry = function (pos, rot, scale, cardFlip, wait, speed, sound) {
        this.WorldPos = pos ? pos.clone() :  new PIXI.Point(0, 0);
        this.WorldRot = rot || 0;
        this.WorldScale = scale ? scale.clone() : new PIXI.Point(1, 1);
        this.CardFlip = cardFlip || 0;
        this.Wait = wait || 0;
        this.Speed = speed || 0;
        this.SoundToPlayAtFinish = sound;
        this.ReversePileLayering = false;
        this.ForceLayer = null;
        this.ForceLayer2 = null;
    };

    SpiderCardAnimator.prototype.BeginAnimationSet = function (numActionsToExpect)
    {
        this.IsInAnimationSet = true;
        this.AnimationDelayTimer = 0;
        this.AnimationList.Clear();
        this.DealCardNum = 0;
        this.IsDeal = false;
    };

    SpiderCardAnimator.prototype.EndAnimationSet = function ()
    {
        this.IsInAnimationSet = false;
    };

    SpiderCardAnimator.prototype.BeginAnimation = function (action, isUndoing)
    {
        if (!this.IsInAnimationSet)
        {
            this.AnimationDelayTimer = 0;
            this.AnimationList.Clear();
            this.FlippedPileList.Clear();
            this.DealCardNum = 0;
            this.IsDeal = false;
        }

        this.AnimatingAction = action;
        this.IsUndoing = isUndoing;
        // save the starting position for each card
        _.forEach (this.SupplyView.CardSupply.GetCardList(), function (card)
        {
            var cardView = this.SupplyView.GetCardView(card);
            if (!this.AnimationList.ContainsKey(cardView))
            {
                // create the animation list entry
                var current = new SpiderCardAnimator.AnimationEntry();
                current.Wait = this.AnimationDelayTimer; // starting location
                current.Speed = 0;
                //cardView.SceneTransform.Decompose(out current.WorldScale, out current.WorldRot, out current.WorldPos);
                // TODO scale and rot
                current.WorldPos = cardView.parent.toGlobal(cardView.position);

                this.AnimationList.Add(cardView, [ current ]);

            }
        }, this);
    };

    SpiderCardAnimator.prototype.ContinueAnimation = function (action, opNum)
    {
        this.SupplyView.UpdatePileChildren(false);

        var AnimSpeed = SpiderCardAnimator.ANIMATION_LENGTH;
        var AnimDelay = SpiderCardAnimator.ANIMATION_DELAY;
        var CardDelaySpeed = SpiderCardAnimator.CARD_DELAY;

        if (!this.SupplyView.CardSupply.EnforceGameRules)
        {
            AnimSpeed = 0.2;
            AnimDelay = 0.05;
            CardDelaySpeed = 0;
        }

        var op = action.Ops[opNum];
        if (op.Opcode == CardOp.Op.Move)
        {
            var fromPile = op.GetPile(CardOp.eMoveParams.SourcePile);
            var toPile = op.GetPile(CardOp.eMoveParams.DestPile);
            var numCards = op.GetNumber(CardOp.eMoveParams.NumCards);

            if (fromPile.Type == "Stock")
            {
                AnimSpeed = SpiderCardAnimator.ANIM_LENGTH_DRAW;
                CardDelaySpeed = SpiderCardAnimator.CARD_DELAY_DRAW;
                AnimDelay = 0.1;
            }

            if (this.IsUndoing)
            {
                // if undoing, swap the piles
                var tmp = fromPile;
                fromPile = toPile;
                toPile = tmp;

                CardDelaySpeed *= 0.75;
                AnimDelay *= 0.75;
                AnimSpeed *= 0.75;
            }

            var fromPileView = this.SupplyView.GetPileView(fromPile);
            var toPileView = this.SupplyView.GetPileView(toPile);
            var rev = false;
            if (numCards < 0)
            {
                numCards = -numCards;
                rev = true;
                //toPileView.ReverseChildOrder = true;
                if (!this.FlippedPileList.ContainsKey(toPileView))
                    this.FlippedPileList.Add(toPileView, toPileView);
            }

            if (fromPile.Type == "Tableau" && toPile.Type == "Foundation")
            {
                // @jarbot: if we're animating to foundation we're preventing the reverse from happening
                rev = false;
                // Make runs animate slower.
                CardDelaySpeed = 0.3;
                AnimSpeed = 0.4;
                AnimDelay = 0;
            }

            if (action.Ops.length > 24)
            {
                AnimDelay *= 0.2; // deal
            }
            if (numCards > 13)
            {
                this.IsDeal = true;
            }
            if (numCards > 12)
            {
                CardDelaySpeed *= 0.1;
            }
            else if (numCards > 6)
            {
                CardDelaySpeed *= 0.25;
            }

            if (fromPileView.CardFacing == PileView.Facing.Hidden ||
                toPileView.CardFacing == PileView.Facing.Hidden)
            {
                AnimSpeed = 0;
                AnimDelay = 0;
                CardDelaySpeed = 0;
            }
            else
            {
                if (this.NextAnimationDelay > 0)
                {
                    this.AnimationDelayTimer += this.NextAnimationDelay;

                    this.NextAnimationDelay = 0;
                }
            }

            var tmpCardList = _.clone(toPile.GetCards()),
                cardCount = tmpCardList.length,
                fromTop = function (N) {
                    if (cardCount < N) return null;
                    else if (N <= 0) return null;
                    else return tmpCardList[cardCount - N];
                };

            var slowDownAnim = false;
            // delay the reveal for face down cards after moving run to foundation
            if(this.movingRunToFoundation) {
                slowDownAnim = true;
            }

            for (var cardNum = 0; cardNum < numCards; cardNum++)
            {
                var cardIdx = cardNum + 1;
                if (rev)
                    cardIdx = numCards - cardNum;

                var card = fromTop(cardIdx);
                var cardView = this.SupplyView.GetCardView(card);

                var next = new SpiderCardAnimator.AnimationEntry();
                next.Wait = this.AnimationDelayTimer;
                next.Speed = AnimSpeed;
                next.ReversePileLayering = rev;

                if(slowDownAnim) {
                    next.Wait = 1.2;
                }

                var cardPos = cardView.GetCardPositionInPile(null, true);
                next.WorldPos = cardView.parent.toGlobal(cardPos);
                if(fromPile.Type !== 'FaceDown') {
                    toPileView.parent.setChildIndex(toPileView, toPileView.parent.children.length - 1);
                }

                next.WorldPos = cardView.parent.toGlobal(new PIXI.Point(cardPos.x, cardPos.y));

                if (toPileView.CardFacing == PileView.Facing.FaceDown)
                {
                    next.CardFlip = 1;
                }
                else
                {
                    next.CardFlip = 0;
                }

                if (this.IsDeal && numCards < 104)
                {
                    next.ForceLayer = CardView.TopLayer + 1 + card.Supply.Count - this.DealCardNum;
                    next.ForceLayer2 = CardView.TopLayer + 1 + card.Supply.Count + this.DealCardNum;
                    this.DealCardNum++;
                }

                // SPIDER RUN TABLEAU TO FOUNDATION:
                if (fromPile.Type == "Tableau" && toPile.Type == "Foundation")
                {

                    // There is a weird bug where after undos the pile we're animating gets put underneath the fromPile
                    // lets avoid that with this nice hack
                    this.SupplyView.AddChild(toPileView);

                    this.movingRunToFoundation = true;
                    cardView.LayerWhileAnimating = CardView.TopLayer + numCards - cardNum;

                    next.ForceLayer = cardView.LayerWhileAnimating;

                    var additionalWait = 0.0; // This is variable based on the timing of the tableau-to-foundation animation.

                    // Wait a little bit, and then unset LayerWhileAnimating to make sure that cards moved first
                    // don't occlude cards moved after (ideally when the card animates off the source pile).
                    (function(tCardIdx, tCardNum, that, tCardView) {

                        window.setTimeout(function(){
                            toPile.moveCardInPile(numCards - 1, tCardIdx - 1);
                            that.SupplyView.UpdatePileChildren(false);
                        }.bind(that), (additionalWait + next.Wait) * 1000);

                        Tween.Start(cardView)
                            .Wait(additionalWait)
                            .Call(function(){
                                if(tCardNum == 0) {
                                    var effectStart,
                                        effectEnd = {x: toPileView.worldTransform.tx, y: toPileView.worldTransform.ty};

                                    if (fromPileView.StackedPile.Pile.Count > 0) {
                                        //fromScreen = SupplyView.GetCardView(fromPileView.StackedPile.Pile.Top).ToGlobal(Vector3.Zero);
                                        effectStart = that.SupplyView.GetCardView(fromPileView.StackedPile.Pile.Top);
                                    } else {
                                        //fromScreen = fromPileView.StackedPile.ToGlobal(Vector3.Zero);
                                        effectStart = fromPileView.StackedPile;
                                    }

                                    effectStart = {
                                        'x': effectStart.worldTransform.tx,
                                        'y': effectStart.worldTransform.ty
                                    };
                                    that.trailParticles(tCardView, effectStart, effectEnd);
                                }
                            }.bind(that));

                    })(cardIdx, cardNum, this, cardView);
                } else {
                    this.movingRunToFoundation = false;
                }

                if (fromPile.Type != "Stock")
                {
                    if (toPile.Type == "Foundation" && cardNum == 0)
                    {
                        // playing the sound in the animator
                        //next.SoundToPlayAtFinish = "completeStack_chime";
                    }
                    else if (this.SupplyView.GetPileView(fromPile).CardFacing == PileView.Facing.FaceDown && this.SupplyView.GetPileView(toPile).CardFacing == PileView.Facing.FaceUp)
                    {
                        next.SoundToPlayAtFinish = "flipCard";
                    }
                }

                this.AnimationList.Get(cardView).push(next);

                if (numCards > 1)
                    this.AnimationDelayTimer += CardDelaySpeed;
            }

            this.AnimationDelayTimer += AnimDelay;
        }
    };

    //   Object AnimationLock = new Object();

    SpiderCardAnimator.prototype.EndAnimation = function (action, callThisWhenFinished)
    {
        var tweensToFinish = 0;
        this.TweenCache.Clear();

        // now, actually perform all the tweens that we set up earlier
         _.forEach (this.AnimationList.GetKeys(), function (node)
        {
            var tweenList = this.AnimationList.Get(node);
            if (tweenList.length < 2)
                return; // no anim for this node

            if (node instanceof CardView)
                node.Animating = true;

            tweensToFinish++;

            var tween;
            if (this.TweenCache.ContainsKey(node))
            {
                tween = this.TweenCache.Get(node).Then();
            }
            else
            {
                var tweens = Tween.GetTweens(node);
                if (tweens != null && tweens.length > 0)
                    tween = tweens[0].Then();
                else
                    tween = Tween.Start(node);

                // TODO tween.Completed.add(function (t, n) { this.TweenCache.Remove(n); }.bind(this) ); // TODO leak?

                this.TweenCache.Add(node, tween);
            }

            var prevWait = 0;
            for (var i = 0; i < tweenList.length; i++)
            {
                var tweenEntry = tweenList[i];

                // First, take all of the world transform stuff and take it back to the node's local space.
                //Vector3 pos = Vector3.TransformCoordinate(tweenEntry.WorldPos, node.Parent.InverseSceneTransform);
                var pos = node.parent.toLocal(tweenEntry.WorldPos);
                //Vector3 scale = Vector3.TransformNormal(tweenEntry.WorldScale, node.Parent.InverseSceneTransform);
                var scale = node.scale.clone();

                if (i == 0)
                {
                    node.SetPosition(pos);
                    node.SetScale(scale);
                }
                else
                {
                    tween = tween.Wait(tweenEntry.Wait - prevWait).Then();
                    if (tweenEntry.Wait > 0 && this.nextAnimationAction != null)
                    {
                        var callAnimation = this.nextAnimationAction;
                        tween = tween.Call(callAnimation).And();
                        this.nextAnimationAction = null;
                    }
                    if (tweenEntry.ForceLayer2 != null && node instanceof CardView)
                    {
                        tween = tween.Call(function () { node.LayerWhileAnimating = tweenEntry.ForceLayer2.Value}).And();
                    }
                    prevWait = tweenEntry.Wait + tweenEntry.Speed;

                    tween = tween.MoveTo(pos, tweenEntry.Speed, TWEEN.Easing.Cubic.Out).And()
                        .ScaleTo(scale, tweenEntry.Speed,TWEEN.Easing.Cubic.Out);

                    if (node instanceof CardView)
                    tween = tween.And().CustomTo(
                            node.SetCardFlipAngle.bind(node),
                            node.GetCardFlipAngle.bind(node),
                            tweenEntry.CardFlip,
                            tweenEntry.Speed,
                            TWEEN.Easing.Exponential.Out);
                }

                tween = tween.Then();

                if (tweenEntry.ForceLayer != null)
                {
                    tween = tween.Then().Call(function (n)
                    {
                        if (n instanceof CardView)
                            n.LayerWhileAnimating = null;
                    });
                }

                if (tweenEntry.SoundToPlayAtFinish != null)
                {
                    tween.Call(function () { EngineManagers.Sounds.PlaySound(tweenEntry.SoundToPlayAtFinish); });
                }
            }
            tween = tween.Call(this.StopAnimating.bind(this));

            tween = tween.Call(function () { tweensToFinish = this.EndAnimTrigger(tweensToFinish, callThisWhenFinished); }.bind(this));

//                EngineManagers.RttManager.IncludeToRtt(node);
        }, this);
        this.AnimationList.Clear();
        this.TweenCache.Clear();

        //lock (AnimationLock)
        //{
            if (tweensToFinish == 0)
            {
                callThisWhenFinished(action);
            }
        //}
    };

    SpiderCardAnimator.prototype.GetTweenedTimeScale = function (node, prop, timeScale) // TODO where called?
    {
        timeScale = EngineManagers.TimeScale;
        return timeScale;
    };

    SpiderCardAnimator.prototype.SetTweenedTimeScale = function (node, prop, timeScale)
    {
        EngineManagers.TimeScale = timeScale;
    };

    SpiderCardAnimator.prototype.StopAnimating = function (node)
    {
        if (node instanceof CardView)
            node.Animating = false;
        //foreach (PileView p in FlippedPileList.Keys)
        //{
        //    p.ReverseChildOrder = false;
        //}
        this.FlippedPileList.Clear();
    };

    // TODO public event ShuffleFinishedDelegate OnShuffleFinished;
    SpiderCardAnimator.prototype.EndAnimTrigger = function (/* ref */ tweensToFinish, onComplete)
    {
        //lock (AnimationLock)
        //{
            tweensToFinish--;
            if (tweensToFinish == 0)
            {
                this.movingRunToFoundation = false;
                if (this.IsShuffling)
                {
                    this.IsShuffling = false;
                    if (this.OnShuffleFinished != null)
                        this.OnShuffleFinished();
                }
                if (onComplete != null)
                {
                    onComplete(this.AnimatingAction);
                }
            }
        //}
        return tweensToFinish;
    };

    SpiderCardAnimator.prototype.BeginShuffleAnimation = function ()
    {
        if (this.WinAnimator != null)
            this.WinAnimator.EndAnimation();
        this.IsShuffling = true;
    };

    SpiderCardAnimator.prototype.IsShuffleAnimationRunning = function ()
    {
        return this.IsShuffling;
    };

    /// <summary>
    /// Instantiate and begin the win animation.
    /// </summary>
    SpiderCardAnimator.prototype.TriggerWinAnimation = function (endAnimationCallback)
    {
        if (this.SupplyView.CardSupply.Authority.IsChallenge)
        {
            this.WinAnimator = null;
            if (endAnimationCallback != null)
                endAnimationCallback();
        }
        else
        {
            if (this.SupplyView.CurrentLayout == SupplyView.LayoutState.VerticalView)
            {
                if (endAnimationCallback != null)
                    endAnimationCallback();
                return; // snapped, no win anim
            }

            this.WinAnimator = this.SupplyView.CreateGameEndAnimator();

            this.WinAnimator.BeginAnimation(endAnimationCallback, null, null, false); // Currently this only supports win animations that trigger when animation is complete; not ones that trigger during the movement of the last card.
        }
    };

    SpiderCardAnimator.prototype.ShouldShowEndingPopup = function ()
    {
        if (this.WinAnimator == null)
            return true;
        else
            return this.WinAnimator.ShouldShowEndingPopup();
    };

    SpiderCardAnimator.prototype.DoesAnimationBlockInput = function (action)
    {
        // animations that move cards to the foundation block input!
        for (var i = 0; i < action.Ops.length; i++)
        {
            var op = action.Ops[i];
            if (op.Opcode == CardOp.Op.Move)
            {
                if (op.GetPile(CardOp.eMoveParams.DestPile).Type == "Foundation")
                    return true;
            }
        }
        return false;
    };

    SpiderCardAnimator.prototype.DelayNextAnimation = function (delaySeconds)
    {
        this.NextAnimationDelay = delaySeconds;
    };

    SpiderCardAnimator.prototype.OnNextAnimationStart = function (action)
    {
        this.nextAnimationAction = action;
    };

    SpiderCardAnimator.prototype.onHide = function() {
        this.cleanUpParticles();
    };

    SpiderCardAnimator.prototype.cleanUpParticles = function() {

        _.each(this.emitters, function(emitter) {
            emitter.destroy();
            EngineManagers.UI.stage[0].removeChild(emitter);
        });

        this.emitters.length = 0;

        if(this.particleLayer) {
            EngineManagers.UI.stage[0].removeChild(this.particleLayer);
            this.particleLayer = null;
        }

        if(this.cleanUpTimeout !== null) {
            window.clearTimeout(this.cleanUpTimeout);
            this.cleanUpTimeout = null;
        }

    };

    return SpiderCardAnimator;

});

